import React, { useEffect } from 'react';
import './glaucoma.less';
import Footer from "../../../components/Footer/Footer";
import { useScrollHeader } from '../../../hooks';

function Glaucoma({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return (
    <div className="Glaucoma">
      <div className='Glaucoma_cover'>
        <div className="Glaucoma_cover-content ta_c c_ff pageMargin">
          <div className="Glaucoma_cover-title">创新青光眼治疗方案</div>
          <div className='Glaucoma_cover-titleEn'>Innovate glaucoma treatment plans</div>
        </div>
      </div>
      <div className='Glaucoma_section'>
        <div className='Glaucoma_section-block'>
          <div className="pageMargin flex_col flex_ai-c">
            <div className='Glaucoma_section-title Glaucoma_linear-gradient'>
              <div>集视医疗正在开发一种青光眼治疗设备，</div>
              无需手术和药物治疗即可修复青光眼患者的缺损视野。
            </div>
          </div>
          <div className='Glaucoma_section-line'></div>
          <div className="pageMargin flex_col flex_ai-c">
            <div className="Glaucoma_section-img">
              <img
                style={{ width: '100%' }}
                src='./images/qgy/qgy-img.png'
                alt=''
              />
            </div>
          </div>
          <div className='Glaucoma_section-line'></div>
          {/* PC端 */}
          <div className="pageMargin flex_col flex_ai-c">
            <div className='Glaucoma_section-bottomPc flex_row gap_100 mt_48 pb_153'>
              <div style={{ width: '40%' }}>
                <div className='fz_28 fw_500 lh_32 mt_40 Glaucoma_linear-gradient'>编号 FST-A03-001</div>
                <div className='fz_24 fw_500 lh_32 mt_10'>适用于青光眼患者受损视野的修复，对晚期青光眼患者的管状视野也有较佳的效果</div>
              </div>
              <div style={{ width: '30%' }}>
                <div className='fz_28 fw_500 lh_32 mt_40 Glaucoma_linear-gradient'>背景</div>
                <div className='fz_16 fw_500 lh_24 mt_10 c_85899E'>青光眼是一类以眼压升高或不高、出现特征性视神经损害和视野缺损的眼病，严重可致视野萎缩甚至失明。</div>
              </div>
              <div style={{ width: '30%' }}>
                <div className='fz_28 fw_500 lh_32 mt_40 Glaucoma_linear-gradient'>意义</div>
                <div className='fz_16 fw_500 lh_24 mt_10 c_85899E'>FST-A03-001通过对大脑皮层和眼周施加特定的电刺激，结合相应的视觉刺激，重新激活青光眼患者受损的视神经元,达到缺损视野修复的效果。</div>
              </div>
            </div>
          </div>
          {/* 移动端 */}
          <div className="Glaucoma_section-bottomMobile">
            <div className='pageMargin flex_col flex_ai-c ta_c'>
              <div className='fz_18 fw_500 lh_21 mt_17 Glaucoma_linear-gradient'>编号 FST-A03-001</div>
              <div className='fz_12 fw_500 lh_16 mt_4 mb_23' style={{ width: '74%' }}>适用于青光眼患者受损视野的修复，对晚期青光眼患者的管状视野也有较佳的效果</div>
            </div>
            <div className='Glaucoma_section-line'></div>
            <div className='pageMargin flex_col flex_ai-c ta_c'>
              <div className='fz_18 fw_500 lh_21 mt_17 Glaucoma_linear-gradient'>背景</div>
              <div className='fz_12 fw_500 lh_16 mt_4 mb_23 c_85899E' style={{ width: '74%' }}>青光眼是一类以眼压升高或不高、出现特征性视神经损害和视野缺损的眼病，严重可致视野萎缩甚至失明。</div>
            </div>
            <div className='Glaucoma_section-line'></div>
            <div className='pageMargin flex_col flex_ai-c ta_c'>
              <div className='fz_18 fw_500 lh_21 mt_17 Glaucoma_linear-gradient'>意义</div>
              <div className='fz_12 fw_500 lh_16 mt_4 mb_40 c_85899E' style={{ width: '74%' }}>FST-A03-001通过对大脑皮层和眼周施加特定的电刺激，结合相应的视觉刺激，重新激活青光眼患者受损的视神经元,达到缺损视野修复的效果。</div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Glaucoma;